import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Budapest" />
        <footer>
          This project was coded by Tanya Furst and is open-sourced on{" "}
          <a
            href="https://github.com/furstcontact/weather-react-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
